import { LoadState } from "@redotech/react-util/load";
import { ConversationTimelineEvent } from "@redotech/redo-model/conversation-timeline";
import { CustomerActivityFilterOptions } from "@redotech/redo-model/customer-activity/customer-activity-filters";
import { CustomerEvent } from "@redotech/redo-model/customer-event/customer-event-definition";
import { Order } from "@redotech/redo-model/order";
import {
  Return,
  ReturnType,
  ReturnTypeEnum,
} from "@redotech/redo-model/return";
import { ComponentType, createContext } from "react";

export enum EventType {
  CONVERSATION = "conversation",
  CUSTOMER = "customer",
}

interface ConversationEventWrapper {
  type: EventType.CONVERSATION;
  event: ConversationTimelineEvent;
}

interface CustomerEventWrapper {
  type: EventType.CUSTOMER;
  event: CustomerEvent;
}

export type CombinedEvent = CustomerEventWrapper | ConversationEventWrapper;

export interface ActionPanelComponentContext {
  ActivityPanel: ComponentType<{
    headerText?: string;
    conversationActivityLoad: LoadState<CombinedEvent[]>;
    customerActivityFilterOptions: CustomerActivityFilterOptions | undefined;
    setCustomerActivityFilterOptions: (
      options: CustomerActivityFilterOptions | undefined,
    ) => void;
  }>;
  DuplicateOrderModal: ComponentType<{
    open: boolean;
    setOpen: (open: boolean) => void;
    order: Order;
  }>;
  MerchantCreateReturnModal: ComponentType<{
    open: boolean;
    setOpen(open: boolean): void;
    returnType: ReturnTypeEnum;
    relocationInfo: {
      preselectedOrder: Order;
      currentView?: string;
      returnQueryParams?: { [key: string]: string };
    };
  }>;
  OrderDetails: ComponentType<{
    order: Order;
    collapsible?: boolean;
    setCancelOrderModalOpen?(open: boolean): void;
    setCreateClaimModalOpen?(open: boolean): void;
    setCreateType?(type: ReturnType): void;
    setDuplicateOrderModalOpen?(open: boolean): void;
    setEditOrderModalOpen?(open: boolean): void;
    setOrderNeedingAction?(order: Order): void;
    setRefundOrderModalOpen?(open: boolean): void;
  }>;
  ReturnDetails: ComponentType<{ returnItem: Return; reloadReturns(): void }>;
}

export const ActionPanelComponentContext =
  createContext<ActionPanelComponentContext>({
    ActivityPanel: () => null,
    DuplicateOrderModal: () => null,
    MerchantCreateReturnModal: () => null,
    OrderDetails: () => null,
    ReturnDetails: () => null,
  });
